import { Controller } from '@hotwired/stimulus'

// Поле «Клуб» в конструкторе турниров: чипы избранных клубов + подсказки.
// Сервер (/account/clubs/suggest) сначала ищет по городам, где у
// пользователя есть избранные клубы, иначе глобально — тогда в подсказке
// «Клуб · Город · Страна».
export default class TournamentClubController extends Controller {
  static targets = ['input', 'dropdown']
  static values = { url: String }

  connect() {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    document.addEventListener('click', this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
    clearTimeout(this.timer)
  }

  pickChip(event) {
    this.inputTarget.value = event.params.name
    this.close()
  }

  search() {
    clearTimeout(this.timer)
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.close()
      return
    }
    this.timer = setTimeout(() => this.fetchSuggestions(query), 300)
  }

  async fetchSuggestions(query) {
    // Отбрасываем устаревшие ответы: медленный запрос не должен
    // перерисовать подсказки поверх результатов более позднего ввода.
    const requestId = (this.lastRequestId = (this.lastRequestId || 0) + 1)
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      if (requestId !== this.lastRequestId || !response.ok) return

      const data = await response.json()
      if (requestId !== this.lastRequestId) return
      this.render(data.suggestions || [])
    } catch {
      this.close()
    }
  }

  render(suggestions) {
    if (!suggestions.length) {
      this.close()
      return
    }

    this.dropdownTarget.innerHTML = ''
    suggestions.forEach(({ name, label }) => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'tournament-club-suggestion'
      item.textContent = label
      item.addEventListener('click', () => {
        this.inputTarget.value = name
        this.close()
      })
      this.dropdownTarget.appendChild(item)
    })
    this.dropdownTarget.classList.remove('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
    this.dropdownTarget.innerHTML = ''
  }
}
